import { JetView } from 'webix-jet';
import { devConfig, profile, urlJs, walletcode } from 'config/config';

/**
 * Class representing a sports betting view.
 * @extends JetView
 */
export default class sportView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        var lng = 'es-ES'; // Default language set to Spanish
        if (this.app.getService('locale').getLang() == 'en') {
            lng = 'en'; // Change language to English if set
        } else {
            lng = 'es-ES'; // Default to Spanish
        }
        var skinIdITN; // Variable to hold skin ID
        if (profile.skinIdITN == undefined || profile.skinIdITN == undefined || profile.skinIdITN == null) {
            skinIdITN = 'doradobet'; // Default skin ID if not defined
        } else {
            skinIdITN = profile.skinIdITN; // Use defined skin ID
        }
        var typeSkinITN = '0'; // Variable to hold skin type
        var skinJsITN = ''; // Variable to hold skin JavaScript path
        typeSkinITN = profile.typeSkinITN; // Get skin type from profile
        skinJsITN = profile.skinJsITN; // Get skin JavaScript path from profile

        // Load skin JavaScript if typeSkinITN is '1'
        if (typeSkinITN == '1') {
            webix.require([skinJsITN], function () {
                var options = {
                    token: profile.TokenSportsbook, // Token for sportsbook
                    skinid: skinIdITN, // Skin ID
                    walletcode: profile.walletcodeSportbookITN, // Wallet code
                    full: true, // Full mode
                    page: 'vfec', // Page identifier
                    lang: lng, // Language
                    fixed: false, // Fixed mode
                };
                options.isHashMode = false; // Disable hash mode
                options.isHashClassesMode = true; // Enable hash classes mode
                options.placebetcallback = function (object) {
                    try {
                        // Check if BetPhone is defined in profile
                        if (profile.BetPhone != undefined && profile.BetPhone) {
                            webix
                                .ui({
                                    view: 'window',
                                    id: 'windowBetPhone', // Window ID for phone betting
                                    move: false, // Disable window movement
                                    position: 'center', // Center position
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Enviar SMS'), // Label for SMS sending
                                                align: 'center',
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide window on close
                                                },
                                            },
                                        ],
                                    },
                                    body: {
                                        view: 'form',
                                        id: 'betPhoneForm', // Form ID for phone betting
                                        elements: [
                                            {
                                                view: 'text',
                                                label: _('Ingrese su celular:'), // Phone input label
                                                name: 'Phone', // Input name
                                                labelWidth: 150,
                                                labelPosition: 'top',
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'text',
                                                label: _('Confirme  celular:'), // Confirm phone input label
                                                name: 'Phone2', // Input name
                                                labelWidth: 150,
                                                labelPosition: 'top',
                                                required: true, // Required field
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Cancel button label
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Hide window on cancel
                                                            $$('betPhoneForm').setValues(
                                                                $$('betPhoneForm').getCleanValues(), // Reset form values
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form',
                                                        value: _('Enviar'), // Send button label
                                                        click: function ($e) {
                                                            var values = $$('betPhoneForm').getValues(); // Get form values
                                                            let params = {
                                                                Phone: values.Phone, // Phone number
                                                                Type: 'Bets', // Type of bet
                                                                Code: object[0].betId, // Bet ID
                                                            };
                                                            if (
                                                                $$('betPhoneForm').validate() // Validate form
                                                            ) {
                                                                if (
                                                                    values.Phone == values.Phone2 // Check if phone numbers match
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Betshop/BetPhoneBetshop', // API endpoint for phone betting
                                                                            params,
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var json = JSON.parse(
                                                                                        text, // Parse response
                                                                                    );
                                                                                    if (
                                                                                        json.HasError // Check for errors in response
                                                                                    ) {
                                                                                        webix.message({
                                                                                            title: _(
                                                                                                '¡Error!', // Error title
                                                                                            ),
                                                                                            type: 'alert-error',
                                                                                            text: json.AlertMessage, // Error message
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Apuesta Confirmada', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('betPhoneForm').setValues(
                                                                        $$('betPhoneForm').getCleanValues(), // Reset form values
                                                                    );
                                                                    this.getTopParentView().hide(); // Hide window after sending
                                                                } else {
                                                                    webix.message({
                                                                        title: _(
                                                                            '¡Error!', // Error title
                                                                        ),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Celular y confirmar celular deben coincidir', // Error message for phone mismatch
                                                                        ),
                                                                    });
                                                                }
                                                            } else {
                                                                webix.message({
                                                                    title: _(
                                                                        '¡Error!', // Error title
                                                                    ),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Completa los campos...', // Error message for incomplete fields
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function () {
                                                    this.validate(); // Validate on change
                                                },
                                            },
                                        },
                                    },
                                })
                                .show(); // Show the phone betting window
                        } else {
                            // Check if BetEmail is defined in profile
                            if (profile.BetEmail != undefined && profile.BetEmail) {
                                webix
                                    .ui({
                                        view: 'window',
                                        id: 'windowBetEmail', // Window ID for email betting
                                        move: false, // Disable window movement
                                        position: 'center', // Center position
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: 'Enviar Correo', // Label for email sending
                                                    align: 'center',
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close', // Close icon
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide window on close
                                                    },
                                                },
                                            ],
                                        },
                                        body: {
                                            view: 'form',
                                            id: 'betEmailForm', // Form ID for email betting
                                            elements: [
                                                {
                                                    view: 'text',
                                                    label: 'Ingrese su correo electrónico:', // Email input label
                                                    name: 'Email', // Input name
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'text',
                                                    label: 'Confirme correo electrónico:', // Confirm email input label
                                                    name: 'Email2', // Input name
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: 'Cancelar', // Cancel button label
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Hide window on cancel
                                                                $$('betEmailForm').setValues(
                                                                    $$('betEmailForm').getCleanValues(), // Reset form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: 'Enviar', // Send button label
                                                            click: function ($e) {
                                                                var values = $$('betEmailForm').getValues(); // Get form values
                                                                let params = {
                                                                    Email: values.Email, // Email address
                                                                    Type: 'Bets', // Type of bet
                                                                    Code: object[0].betId, // Bet ID
                                                                };
                                                                if (
                                                                    $$('betEmailForm').validate() // Validate form
                                                                ) {
                                                                    if (
                                                                        values.Email == values.Email2 // Check if email addresses match
                                                                    ) {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'BetShop/BetEmailBetshop', // API endpoint for email betting
                                                                                params,
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message
                                                                                        );
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        var json = JSON.parse(
                                                                                            text, // Parse response
                                                                                        );
                                                                                        if (
                                                                                            json.HasError // Check for errors in response
                                                                                        ) {
                                                                                            webix.message({
                                                                                                title: '¡Error!', // Error title
                                                                                                type: 'alert-error',
                                                                                                text: json.AlertMessage, // Error message
                                                                                            });
                                                                                        } else {
                                                                                            webix.message(
                                                                                                'Apuesta Confirmada', // Success message
                                                                                            );
                                                                                        }
                                                                                    },
                                                                                },
                                                                            );
                                                                        $$('betEmailForm').setValues(
                                                                            $$('betEmailForm').getCleanValues(), // Reset form values
                                                                        );
                                                                        this.getTopParentView().hide(); // Hide window after sending
                                                                    } else {
                                                                        webix.message({
                                                                            title: '¡Error!', // Error title
                                                                            type: 'alert-error',
                                                                            text: 'Correo y confirmar correo deben coincidir', // Error message for email mismatch
                                                                        });
                                                                    }
                                                                } else {
                                                                    webix.message({
                                                                        title: '¡Error!', // Error title
                                                                        type: 'alert-error',
                                                                        text: 'Completa los campos...', // Error message for incomplete fields
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the email betting window
                            }
                        }
                    } catch (e) {
                        console.log(e); // Log any errors
                    }
                };
                var BIA = new AltenarSportsbook(
                    '#BIA_client_container', // Container for sportsbook
                    options,
                );
                document.getElementById('BIA_client_container').parentNode.style.overflow = 'scroll'; // Set overflow style for container
            });
        } else if (typeSkinITN == '4') {
            webix.require([skinJsITN], function () {
                window.altenarWSDK.init({
                    integration: skinIdITN, // Integration ID
                    culture: lng, // Language
                    token: profile.TokenSportsbook, // Token for sportsbook
                    oddsFormat:
                        profile.oddsFormat != undefined
                            ? profile.oddsFormat // Odds format from profile
                            : 0,
                });
                window.altenarWSDK.set({ token: profile.TokenSportsbook }); // Set token
                window.ASB = window.altenarWSDK.addSportsBook({
                    props: {
                        routerType: 'memory', // Router type
                        page: 'virtual', // Page identifier
                        onBetPlacement: (betIds) => {
                            try {
                                if (devConfig.getOnRelationshipUserOnline()) {
                                    let userRelationship = JSON.parse(
                                        localStorage.getItem(
                                            'relationshipUserOnline', // Get user relationship from local storage
                                        ),
                                    );
                                    webix
                                        .ui({
                                            id: 'filterPopup31',
                                            view: 'window',
                                            position: 'center', // Center position
                                            modal: true, // Modal window
                                            css: {
                                                'border-width': '0px !important',
                                                'border-radius': '10px !important',
                                            },
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                                                            _(
                                                                'CONFIRMACION DE APUESTA', // Confirmation label
                                                            ) +
                                                            `</span>`,
                                                    },
                                                    {
                                                        view: 'icon',
                                                        icon: 'wxi-close', // Close icon
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Hide window on close
                                                        },
                                                    },
                                                ],
                                                css: {
                                                    'background-color': '#404563', // Toolbar background color
                                                    color: 'white !important', // Toolbar text color
                                                },
                                            },
                                            body: {
                                                width: 500,
                                                height: 250,
                                                padding: 10,
                                                rows: [
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='font-size: 20px; font-weight: bold'>` +
                                                            _('ID:') +
                                                            ' ' +
                                                            userRelationship.id +
                                                            `</span>`,
                                                        css: {
                                                            'text-align': 'center', // Center text
                                                        },
                                                    },
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='font-size: 20px; font-weight: bold'>` +
                                                            _('DOCUMENTO:') +
                                                            ' ' +
                                                            userRelationship.value +
                                                            `</span>`,
                                                        css: {
                                                            'text-align': 'center', // Center text
                                                        },
                                                    },
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='font-size: 20px; font-weight: bold; text-transform: uppercase'>` +
                                                            userRelationship.name +
                                                            `</span>`,
                                                        css: {
                                                            'text-align': 'center', // Center text
                                                        },
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: 'button',
                                                                value: 'Cerrar sesión', // Logout button label
                                                                autowidth: true,
                                                                click: function () {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Account/LogoutRelationshipUser', // API endpoint for logout
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    localStorage.removeItem(
                                                                                        'relationshipUserOnline', // Remove user relationship from local storage
                                                                                    );
                                                                                    devConfig.setRelationshipUserOnline(
                                                                                        '',
                                                                                    );
                                                                                    $$('BIA_client').show(); // Show client view
                                                                                    $$('BIA_client_2').hide(); // Hide secondary client view
                                                                                    $$('BIA_client_ID').setValue(''); // Reset client ID
                                                                                    $$('BIA_client_ID').refresh(); // Refresh client ID
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    localStorage.removeItem(
                                                                                        'relationshipUserOnline', // Remove user relationship from local storage
                                                                                    );
                                                                                    devConfig.setRelationshipUserOnline(
                                                                                        '',
                                                                                    );
                                                                                    $$('BIA_client').show(); // Show client view
                                                                                    $$('BIA_client_2').hide(); // Hide secondary client view
                                                                                    $$('BIA_client_ID').setValue(''); // Reset client ID
                                                                                    $$('BIA_client_ID').refresh(); // Refresh client ID
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Hide window after logout
                                                                },
                                                            },
                                                            {
                                                                view: 'button',
                                                                type: 'form',
                                                                value: 'Continuar apostando', // Continue betting button label
                                                                css: 'webix_primary',
                                                                autowidth: true,
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Hide window on continue
                                                                },
                                                            },
                                                        ],
                                                        css: {
                                                            display: 'flex',
                                                            'justify-content': 'center', // Center content
                                                            'align-items': 'center', // Align items
                                                            gap: '10px',
                                                            'margin-top': '15px !important',
                                                        },
                                                    },
                                                ],
                                                css: {
                                                    display: 'flex',
                                                    'flex-direction': 'column', // Column layout
                                                    'justify-content': 'center', // Center content
                                                    'align-items': 'center', // Align items
                                                    gap: '0px !important',
                                                },
                                            },
                                        })
                                        .show(); // Show confirmation window
                                } else {
                                    // Check if BetPhone is defined in profile
                                    if (profile.BetPhone != undefined && profile.BetPhone) {
                                        webix
                                            .ui({
                                                view: 'window',
                                                id: 'windowBetPhone', // Window ID for phone betting
                                                move: false, // Disable window movement
                                                position: 'center', // Center position
                                                head: {
                                                    view: 'toolbar',
                                                    cols: [
                                                        {
                                                            view: 'label',
                                                            label: 'Enviar SMS', // Label for SMS sending
                                                            align: 'center',
                                                        },
                                                        {
                                                            view: 'icon',
                                                            icon: 'wxi-close', // Close icon
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Hide window on close
                                                            },
                                                        },
                                                    ],
                                                },
                                                body: {
                                                    view: 'form',
                                                    id: 'betPhoneForm', // Form ID for phone betting
                                                    elements: [
                                                        {
                                                            view: 'text',
                                                            label: 'Ingrese su celular:', // Phone input label
                                                            name: 'Phone', // Input name
                                                            labelWidth: 150,
                                                            labelPosition: 'top',
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            view: 'text',
                                                            label: 'Confirme  celular:', // Confirm phone input label
                                                            name: 'Phone2', // Input name
                                                            labelWidth: 150,
                                                            labelPosition: 'top',
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    view: 'button',
                                                                    value: 'Cancelar', // Cancel button label
                                                                    click: function () {
                                                                        this.getTopParentView().hide(); // Hide window on cancel
                                                                        $$('betPhoneForm').setValues(
                                                                            $$('betPhoneForm').getCleanValues(), // Reset form values
                                                                        );
                                                                    },
                                                                },
                                                                {
                                                                    view: 'button',
                                                                    type: 'form',
                                                                    value: 'Enviar', // Send button label
                                                                    click: function ($e) {
                                                                        var values = $$('betPhoneForm').getValues(); // Get form values
                                                                        let params = {
                                                                            Phone: values.Phone, // Phone number
                                                                            Type: 'Bets', // Type of bet
                                                                            Code: betIds[0], // Bet ID
                                                                        };
                                                                        if (
                                                                            $$('betPhoneForm').validate() // Validate form
                                                                        ) {
                                                                            if (
                                                                                values.Phone == values.Phone2 // Check if phone numbers match
                                                                            ) {
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({
                                                                                        'Content-type':
                                                                                            'application/json', // Set content type
                                                                                    })
                                                                                    .post(
                                                                                        devConfig.geturlApi() +
                                                                                            'Betshop/BetPhoneBetshop', // API endpoint for phone betting
                                                                                        params,
                                                                                        {
                                                                                            error: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                webix.message(
                                                                                                    'Error! ', // Error message
                                                                                                );
                                                                                            },
                                                                                            success: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                var json = JSON.parse(
                                                                                                    text, // Parse response
                                                                                                );
                                                                                                if (
                                                                                                    json.HasError // Check for errors in response
                                                                                                ) {
                                                                                                    webix.message({
                                                                                                        title: '¡Error!', // Error title
                                                                                                        type: 'alert-error',
                                                                                                        text: json.AlertMessage, // Error message
                                                                                                    });
                                                                                                } else {
                                                                                                    webix.message(
                                                                                                        'Apuesta Confirmada', // Success message
                                                                                                    );
                                                                                                }
                                                                                            },
                                                                                        },
                                                                                    );
                                                                                $$('betPhoneForm').setValues(
                                                                                    $$('betPhoneForm').getCleanValues(), // Reset form values
                                                                                );
                                                                                this.getTopParentView().hide(); // Hide window after sending
                                                                            } else {
                                                                                webix.message({
                                                                                    title: '¡Error!', // Error title
                                                                                    type: 'alert-error',
                                                                                    text: 'Celular y confirmar celular deben coincidir', // Error message for phone mismatch
                                                                                });
                                                                            }
                                                                        } else {
                                                                            webix.message({
                                                                                title: '¡Error!', // Error title
                                                                                type: 'alert-error',
                                                                                text: 'Completa los campos...', // Error message for incomplete fields
                                                                            });
                                                                        }
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                    elementsConfig: {
                                                        on: {
                                                            onChange: function () {
                                                                this.validate(); // Validate on change
                                                            },
                                                        },
                                                    },
                                                },
                                            })
                                            .show(); // Show the phone betting window
                                    } else {
                                        // Check if BetEmail is defined in profile
                                        if (profile.BetEmail != undefined && profile.BetEmail) {
                                            webix
                                                .ui({
                                                    view: 'window',
                                                    id: 'windowBetEmail', // Window ID for email betting
                                                    move: false, // Disable window movement
                                                    position: 'center', // Center position
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: 'Enviar Correo', // Label for email sending
                                                                align: 'center',
                                                            },
                                                            {
                                                                view: 'icon',
                                                                icon: 'wxi-close', // Close icon
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Hide window on close
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    body: {
                                                        view: 'form',
                                                        id: 'betEmailForm', // Form ID for email betting
                                                        elements: [
                                                            {
                                                                view: 'text',
                                                                label: 'Ingrese su correo electrónico:', // Email input label
                                                                name: 'Email', // Input name
                                                                labelWidth: 150,
                                                                labelPosition: 'top',
                                                                required: true, // Required field
                                                            },
                                                            {
                                                                view: 'text',
                                                                label: 'Confirme correo electrónico:', // Confirm email input label
                                                                name: 'Email2', // Input name
                                                                labelWidth: 150,
                                                                labelPosition: 'top',
                                                                required: true, // Required field
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        view: 'button',
                                                                        value: 'Cancelar', // Cancel button label
                                                                        click: function () {
                                                                            this.getTopParentView().hide(); // Hide window on cancel
                                                                            $$('betEmailForm').setValues(
                                                                                $$('betEmailForm').getCleanValues(), // Reset form values
                                                                            );
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        type: 'form',
                                                                        value: 'Enviar', // Send button label
                                                                        click: function ($e) {
                                                                            var values = $$('betEmailForm').getValues(); // Get form values
                                                                            let params = {
                                                                                Email: values.Email, // Email address
                                                                                Type: 'Bets', // Type of bet
                                                                                Code: betIds[0], // Bet ID
                                                                            };
                                                                            if (
                                                                                $$('betEmailForm').validate() // Validate form
                                                                            ) {
                                                                                if (
                                                                                    values.Email == values.Email2 // Check if email addresses match
                                                                                ) {
                                                                                    webix
                                                                                        .ajax()
                                                                                        .headers({
                                                                                            'Content-type':
                                                                                                'application/json', // Set content type
                                                                                        })
                                                                                        .post(
                                                                                            devConfig.geturlApi() +
                                                                                                'BetShop/BetEmailBetshop', // API endpoint for email betting
                                                                                            params,
                                                                                            {
                                                                                                error: function (
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    webix.message(
                                                                                                        'Error! ', // Error message
                                                                                                    );
                                                                                                },
                                                                                                success: function (
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    var json =
                                                                                                        JSON.parse(
                                                                                                            text, // Parse response
                                                                                                        );
                                                                                                    if (
                                                                                                        json.HasError // Check for errors in response
                                                                                                    ) {
                                                                                                        webix.message({
                                                                                                            title: '¡Error!', // Error title
                                                                                                            type: 'alert-error',
                                                                                                            text: json.AlertMessage, // Error message
                                                                                                        });
                                                                                                    } else {
                                                                                                        webix.message(
                                                                                                            'Apuesta Confirmada', // Success message
                                                                                                        );
                                                                                                    }
                                                                                                },
                                                                                            },
                                                                                        );
                                                                                    $$('betEmailForm').setValues(
                                                                                        $$(
                                                                                            'betEmailForm',
                                                                                        ).getCleanValues(), // Reset form values
                                                                                    );
                                                                                    this.getTopParentView().hide(); // Hide window after sending
                                                                                } else {
                                                                                    webix.message({
                                                                                        title: '¡Error!', // Error title
                                                                                        type: 'alert-error',
                                                                                        text: 'Correo y confirmar correo deben coincidir', // Error message for email mismatch
                                                                                    });
                                                                                }
                                                                            } else {
                                                                                webix.message({
                                                                                    title: '¡Error!', // Error title
                                                                                    type: 'alert-error',
                                                                                    text: 'Completa los campos...', // Error message for incomplete fields
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                        elementsConfig: {
                                                            on: {
                                                                onChange: function () {
                                                                    this.validate(); // Validate on change
                                                                },
                                                            },
                                                        },
                                                    },
                                                })
                                                .show(); // Show the email betting window
                                        }
                                    }
                                }
                            } catch (e) {
                                console.log(e); // Log any errors
                            }
                        },
                    },
                    container: document.getElementById('BIA_client_container'), // Container for sportsbook
                });
            });
        } else {
            webix.require([skinJsITN], function () {
                var options = {
                    token: profile.TokenSportsbook, // Token for sportsbook
                    skinid: skinIdITN, // Skin ID
                    walletcode: profile.walletcodeSportbookITN, // Wallet code
                    full: true, // Full mode
                    page: 'vfec', // Page identifier
                    lang: lng, // Language
                    fixed: false, // Fixed mode
                };
                var BIA = new AltenarSportsbook(
                    '#BIA_client_container', // Container for sportsbook
                    options,
                );
            });
        }
        if (typeSkinITN == '4') {
            return {
                view: 'template',
                template:
                    "<div id='BIA_client_container' style='overflow: scroll; height: 100%; width: 100%; background-color: black;'></div>", // Template for container
                css: 'webix_template33', // CSS class for styling
            };
        }
        return {
            view: 'template',
            template: "<div id='BIA_client_container' style='overflow: scroll; height: 100%; width: 100%;'></div>", // Template for container
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        if (window.ASB != undefined) {
            window.ASB.remove(); // Remove existing sportsbook instance
        }
    }
}

// FILE DOCUMENTED
